const listsStyles = {
  '.ui-list': { listStyle: 'none', paddingLeft: '0', margin: '0' },
  '.ui-list > li:last-child': { marginBottom: '0' },
  '.ui-list--spaced > li': { marginBottom: '20px' },
  '.ui-list--quarter-spaced > li': { marginBottom: '5px' },
};

export default listsStyles;
